import { Box } from "@/ui";
import { keyframes } from "@emotion/react";

const CHECK_STROKE_LENGTH = 24;
const drawCheckAnimation = keyframes`
  from {
    stroke-dashoffset: ${CHECK_STROKE_LENGTH};
  }
  to {
    stroke-dashoffset: 0;
  }
`;

export default function AnimatedCheckIcon() {
  return (
    <Box flexShrink={0} w="28px" h="28px" display="flex" alignItems="center" justifyContent="center">
      <Box as="svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <Box
          as="path"
          d="M5 12.5L9.2 16.7L19 7"
          stroke="primary"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          sx={{
            strokeDasharray: CHECK_STROKE_LENGTH,
            strokeDashoffset: CHECK_STROKE_LENGTH,
            animation: `${drawCheckAnimation} 0.3s ease-in-out forwards`
          }}
        />
      </Box>
    </Box>
  );
}
